module.exports = __webpack_public_path__ + "img/Support-skill-317.059b7a0a.png";